import React, { Suspense, lazy } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { motion } from 'framer-motion'
import Button from '../components/ui/Button'

const DinoGame = lazy(() => import('../components/DinoGame'))

const container = {
    hidden: { opacity: 0 },
    show: { opacity: 1, transition: { staggerChildren: 0.06, delayChildren: 0.08 } }
}
const item = {
    hidden: { opacity: 0, y: 8 },
    show: { opacity: 1, y: 0 }
}

export default function NotFound() {
    const { pathname } = useLocation()

    return (
        <div className="min-h-[100vh] bg-white dark:bg-zinc-950 text-black dark:text-white">
            <motion.main
                initial="hidden"
                animate="show"
                variants={container}
                className="max-w-3xl px-6 md:px-16 pt-16 pb-24"
            >
                <motion.div variants={item} className="inline-flex items-center gap-2 border-2 border-black dark:border-white px-3 py-1 text-sm font-mono">
                    <motion.span
                        className="inline-block h-2 w-2 rounded-full bg-accent"
                        animate={{ scale: [1, 1.25, 1] }}
                        transition={{ duration: 1.6, repeat: Infinity, ease: 'easeInOut' }}
                    />
                    <span className="text-zinc-600 dark:text-zinc-300">404</span>
                </motion.div>

                <motion.h1
                    variants={item}
                    className="mt-5 text-5xl md:text-6xl font-serif font-extrabold tracking-tight text-balance"
                >
                    Page not found
                </motion.h1>

                <motion.p
                    variants={item}
                    className="mt-3 text-lg text-zinc-700 dark:text-zinc-300 max-w-md"
                >
                    Nothing lives at <code className="px-1 py-0.5 border border-black dark:border-white font-mono">{
                        pathname
                    }</code>. It moved or never existed.
                </motion.p>

                <motion.div
                    variants={item}
                    className="mt-8 flex flex-col sm:flex-row items-center gap-3"
                >
                    <Button as={Link} to="/">← Go home</Button>
                    <Button as={Link} to="/blog" variant="secondary">Explore Blogs</Button>
                </motion.div>

                <motion.div variants={item} className="mt-12 pt-8 border-t-2 border-black dark:border-white">
                    <Suspense fallback={null}>
                        <DinoGame />
                    </Suspense>
                </motion.div>
            </motion.main>
        </div>
    )
}